import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDrawer } from '../../../../content-composer/src/components/Generic/GenericDrawer';

export interface PayrollDetailsDrawerProps {
  isOpen: boolean;
  onToggleDrawer: (rowData: any) => void;
}

const PayrollDetailsDrawer: FC<PayrollDetailsDrawerProps> = ({ isOpen, onToggleDrawer, children }) => {
  const { t } = useTranslation();

  const handleToggleDrawer = useCallback(
    (event: any) => {
      onToggleDrawer(null);
    },
    [onToggleDrawer],
  );

  return (
    <GenericDrawer
      anchor='bottom'
      isOpen={isOpen}
      onToggleDrawer={handleToggleDrawer}
      disableMobileDrawerHeight={true}
      stickDrawerTitleToLeft
      title={t('payrollPage.PayrollTable.PayrollDetailsDrawer.GenericDrawer.Title')}>
      {children}
    </GenericDrawer>
  );
};

export { PayrollDetailsDrawer };
